

























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CommonLayerDrawer from '@/views/designEditor/canvasWindow/layerDrawer/commonLayerDrawer/commonLayerDrawer.vue';

import * as def from '@/definitions'
// TODO document2
import { Document } from '@/model/document2/document';
import { Design } from '@/model/document2/page/surface/design/design'
import { Layer } from '@/model/document2/page/surface/design/layer/layer'
import { UnitHelper } from '@/helper/unitHelper';
import { InsertionHelper } from '@/helper/insertionHelper';
import { PlainTextLayer } from '@/model/document2/page/surface/design/layer/plainTextLayer';
import { DebugHelper } from "@/helper/debugHelper";

import { Rectangle } from '@/utilityModels/rectangle';

@Component({
  components: {
      CommonLayerDrawer
  }
})
export default class PagePreview extends Vue 
{
    @Prop() private document!: Document;
    @Prop() private design! : Design;
    @Prop({default : true}) private isFontLoaded! : boolean;
    @Prop() private isReverse! : boolean;
    @Prop() private touchedLayer! : Layer | null;

    // 差し込み元となる最初のデザインのすべてのレイヤーを取得する
    private get allOriginLayers()
    {
        var page = this.document.pageList[0];
        var surface = page.getSurface(this.document.isReverseSurface);
        var design = surface.getDesign(0);
        return design != null ? design.getAllLayers(false) : [];
    }

    // レイヤーの外接矩形を取得する
    public getLayerBoundingDOMRect(layer : Layer)
    {
        var rectElement = document.getElementById('insertion-editor-page-preview-layer-rect_' + layer.id);
        var r = rectElement ? rectElement.getBoundingClientRect() : new DOMRect();
        return new Rectangle(r.left, r.top, r.width, r.height);
    }

    private get currentDocument() : Document
    {
        return this.$store.getters.document;
    }

    private isInsertableLayer(layer : Layer) : boolean
    {
        return InsertionHelper.isInsertableLayer(layer);
    }

    onDoCommand(command: string, paramater: any)
    {
        this.$emit("doCommand", command, paramater);
    }

    // viewBox幅
    private get viewWidth() : number
    {
        return UnitHelper.convert(this.design.width, "mm", "px");
    }

    // viewBox高さ
    private get viewHeight() : number
    {
        return UnitHelper.convert(this.design.height, "mm", "px");
    }

    // viewBox
    private get viewBox() : string
    {
        return "0 0 " + this.viewWidth + " " + this.viewHeight;
    }

    private get allLayers()
    {
        return this.design.getAllLayers(false);
    }

    private get scale()
    {
        return UnitHelper.convert(1, "mm", "px");
    }

    private get svgStyle()
    {
        var w = 100;
        var h = 100;
        if(this.design.height > this.design.width)
        {
            w = h * this.design.width / this.design.height;
        }
        else
        {
            h = w * this.design.height / this.design.width;
        }
        var x = (100 - w) / 2;
        var y = (100 - h) / 2;

        return {
            position: "absolute",
            top: y + "%",
            left: x + "%",
            width: w + "%",
            height: h + "%",
        };
    }

    // 回転対応
    private get transform()
    {
        var transform = "";
        return transform;
    }

    private getSelectLayerBorderPoints(layer : Layer)
    {
        var points = "";
        for(var i = 0; i < layer.getVertexes().length; ++i)
        {
            if(i > 0) { points += " "; }
            var ver = layer.getVertexes()[i];
            var x = UnitHelper.convert(ver.x, "mm", "px");
            var y = UnitHelper.convert(ver.y, "mm", "px");
            points += x + "," + y;
        }
        return points;
    }

    private getLayerBounds(layer : Layer)
    {
        var bounds = layer.getBoundingRect();
        var x = UnitHelper.convert(bounds.x, "mm", "px");
        var y = UnitHelper.convert(bounds.y, "mm", "px");
        var w = UnitHelper.convert(bounds.width, "mm", "px");
        var h = UnitHelper.convert(bounds.height, "mm", "px");
        return new Rectangle(x, y, w, h);
    }

    // レイヤーをクリック
    private clickLayer(layer : Layer)
    {
        this.onDoCommand("selectLayer", { layer : layer });
    }

    // レイヤーがすべてデザインに含まれるかどうか
    private isLayerInner(layer : Layer)
    {
        for(var i = 0; i < layer.getVertexes().length; ++i)
        {
            var ver = layer.getVertexes()[i];
            if(ver.x < 0 || ver.x > this.design.width || ver.y < 0 || ver.y > this.design.height)
            {
                // はみ出している
                return false;
            }
        }
        return true;
    }

    // レイヤーに触れた
    private onMouse(layer : Layer)
    {
        this.$emit("touchLayer", layer);
    }

    // レイヤーから離れた
    private outMouse()
    {
        this.$emit("touchLayer", null);
    }

    private getLayerRectColor(layer : Layer) : string
    {
        if(this.currentDocument.selectedInsertionWholeColumn < 0)
        {
            return "rgba(0,0,0,0)";
        }
        else if(this.touchedLayer == layer)
        {
            return this.mouseoverLayerColor;
        }
        else
        {
            return this.userConfigThinColor;
        }
    }

    private get userConfigThinColor(){
        return this.$store.getters.userConfigColors.buttonColorRgba;
    }
    private get userConfigRgbColor(){
        return this.$store.getters.userConfigColors.buttonColorRgb;
    }
    private get mouseoverLayerColor(){
        return "rgba(" + this.userConfigRgbColor.r + ", " + this.userConfigRgbColor.g + ", " + this.userConfigRgbColor.b + ", 0.5)";
    }
}

